<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <b-row>
            <b-col sm=9>
                <b-card>
                    <div slot="header">
                        <strong>{{readonly === 0 ? 'View' : 'Edit'}} Config</strong>
                    </div>
                    <div>
                        <div v-if="!loading">
                            <b-form @submit.prevent="updateConfig()">
                                <b-form-group label="Name of Config:" label-for="name">
                                    <b-form-input type="text" v-model="config.name" v-validate="'required'" id="name" name="name" class="form-control" :class="{ 'is-invalid': submitted && verrors.has('name') }" :readonly=!readonly></b-form-input>
                                    <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('name') }}</div>
                                </b-form-group>
                                <b-form-group label="Models:" label-for="models">
                                    <multiselect v-model="value" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="false" placeholder="search ..." :show-labels="false" label="name" track-by="id" :preselect-first="false" :hideSelected="false" :disabled=!readonly>
                                        <template slot="selection" slot-scope="{ values, search }">
                                            <!-- <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Model selected</span> -->
                                        </template>
                                    </multiselect>
                                </b-form-group>
                                <span>Configuration:</span>
                                <network :config="config" :changed="changed" :changes="changes"></network>
                            </b-form>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col sm3>
                <b-card v-if="readonly">
                    <div slot="header">
                        <strong>Config Changes</strong>
                    </div>
                    <ul id="eg1">
                        <li v-for="change in this.changed" v-bind:key="change.param">
                            {{ change.name }} : {{ change.value}}
                        </li>
                    </ul>
                    <div class="text-center">
                        <button class="btn btn-primary" @click.prevent="updateConfig">Save Config</button>
                        <!-- <button v-if="kount" class="btn btn-secondary" @click.prevent="onReset">Reset</button> -->
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<!--
default vale: https://michaelstivala.com/setting-the-default-value-of-a-select-tag-in-vuejs/
https://medium.com/@hugodesigns/how-to-use-the-most-complete-selecting-solution-for-vue-js-f991b2605364
https://medium.com/employbl/build-tagging-with-vue-multiselect-and-laravel-tags-960c260df438

saving selected tags:
https://quickadminpanel.com/blog/add-tags-to-articles-laravel-many-to-many-relationships-with-select2/

for selected tags using only ids:
https://github.com/shentao/vue-multiselect/issues/133
-->

<script>
import Multiselect from 'vue-multiselect'
import Network from "@/readynet/configs/network/index";

export default {
    components: {
        Multiselect,
        'network': Network,
    },
    data() {
        return {
            config: { "name": "", "snippet": { "dhcp": { "dhcp": { "lan": { "ra": "", "limit": "", "start": "", "dhcpv6": "", "interface": "", "leasetime": "", "ra_management": "" }, "wan": { "ignore": "", "interface": "" } } }, "system": { "system": [{ "hostname": "", "log_size": "", "timezone": "", "cronloglevel": "" }] }, "network": { "device": { "lan_dev": { "name": "", "macaddr": "" }, "wan_dev": { "name": "", "macaddr": "" } }, "switch": [{ "name": "", "reset": "", "enable_vlan": "" }], "interface": { "lan": { "type": "", "proto": "", "ifname": "", "ipaddr": "", "netmask": "" }, "wan": { "proto": "", "ifname": "" }, "wan6": { "proto": "", "ifname": "" }, "wwan": { "proto": "" }, "loopback": { "proto": "", "ifname": "", "ipaddr": "", "netmask": "" } }, "switch_vlan": [{ "vlan": "", "ports": "", "device": "" }, { "vlan": "", "ports": "", "device": "" }] }, "profile": { "default": { "default": { "at": "", "lb": "", "apn": "", "log": "", "ppp": "", "auth": "", "lock": "", "alive": "", "delay": "" } } }, "wireless": { "wifi_iface": { "default_radio0": { "key": "", "mode": "", "ssid": "", "device": "", "network": "", "encryption": "", "wpa_disable_eapol_key_retries": "" }, "default_radio1": { "key": "", "mode": "", "ssid": "", "device": "", "network": "", "encryption": "", "wpa_disable_eapol_key_retries": "" } }, "wifi_device": { "radio0": { "path": "", "type": "", "htmode": "", "hwmode": "", "channel": "", "country": "", "disabled": "0", "legacy_rates": "" }, "radio1": { "path": "", "type": "", "htmode": "", "hwmode": "", "channel": "", "country": "", "disabled": "0", "legacy_rates": "" } } } } },
            changed: [], // {param: "radio0_country", value: "", name: "Radio 0 Reg Domaini"},
            changes: {},
            submitted: false,
            value: [],
            options: [],
            selectedIds: [],
            loading: false,
        };

    },
    // https://github.com/shentao/vue-multiselect/issues/263
    watch: {
        value(newValues) {
            this.selectedIds = newValues.map(obj => obj.id);
        }
    },
    created() {
        this.loading = true;

        let uri = `/api/configs/${this.$route.params.id}`;
        axios.get(uri).then((response) => {
            this.config = response.data.data.config;
            this.options = response.data.data.all_prod_tags;
            this.value = response.data.data.my_prod_tags;
            this.loading = false;
        });
    },
    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        },
        kount: function () {
            return this.changed.length
        },
        readonly() {
            return this.$can('config', 'edit')
        },
    },

    methods: {
        updateConfig() {
            this.submitted = true;
            this.config.product_list = this.selectedIds;
            JSON.stringify(this.config);
            this.$validator.validate().then(valid => {
                if (valid) {
                    let uri = `/api/configs/${this.config.id}`;
                    axios.patch(uri, this.config).then((response) => {

                        if (response.data.success === true) {
                            this.makeToast('info', 'Config updated.');
                        } else {
                            this.makeToast('danger', 'Unable to update config.');
                        }

                    });

                }
            });
        },
        makeToast(variant = null, message = null) {

            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
            // toast.show();
        },

        tabber(event) {
            let text = this.config.snippet,
                originalSelectionStart = event.target.selectionStart,
                textStart = text.slice(0, originalSelectionStart),
                textEnd = text.slice(originalSelectionStart);

            this.config.snippet = `${textStart}\t${textEnd}`
            event.target.value = this.config.snippet // required to make the cursor stay in place.
            event.target.selectionEnd = event.target.selectionStart = originalSelectionStart + 1
        }

    }

}
</script>

<style>
.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #20a8d8;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}

.multiselect__option--highlight {
    background: #20a8d8;
    outline: none;
    color: white;
}

.multiselect__option--highlight:after {
    content: attr(data-select);
    background: #20a8d8;
    color: white;
}
</style>
